import axios from 'axios';
import {empty2null} from './util'
import {hostname} from './const'

const service = axios.create({
    baseURL: hostname,//process.env.BASE_API,
    withCredentials: true,
    timeout: 15000
});

service.interceptors.request.use(
    config => {
        empty2null(config.data);
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

service.interceptors.response.use(
    response => {
        if (response.status !== 200) {
            Promise.reject();
        }
        if (response.data.code == 501) {
            window.location.href = hostname + '/#/login';
        }
        if (response.data.code == 51) {
            window.location.href = hostname + '/#/403';
        }
        return response;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

export default service;
